import api from "../../infra/api";

class ServOcupanteRevisao {
    async listar (codigoOcupante) {
        const response = await api({
            method: "GET",
            url: `/api/v1/OcupanteRevisao?page=1&start=0&limit=999&fields=[]&filter=[{"property":"CodigoOcupante","value":"${codigoOcupante}","and":false}]`
        });

        return response.data;
    }
}

export default new ServOcupanteRevisao();